import React, { useState } from 'react';
import PageIntro from './PageIntro';

function Onderzoek() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Configurable URL - you can change this to your desired endpoint
  const SUBMIT_URL = process.env.REACT_APP_ONDERZOEK_SUBMIT_URL || 'https://coem7pq4a8.execute-api.eu-central-1.amazonaws.com/default/onderzoek-save-mail';


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const formData = new FormData(e.target);
    const email = formData.get('email');
    const phone = formData.get('phone');
    const name = formData.get('naam')

    try {
      const response = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          phone: phone,
          name: name
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        e.target.reset();
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="flex-grow">
      <PageIntro title="Onderzoek" subtitle="Als je het spel gestructureerd maakt, wordt deelnemen toegankelijk"
      subText="Met gepaste trots presenteren we ons onderzoek naar de staat van informatiebeveiliging binnen decentrale overheden in Nederland. Interessant voor iedereen die zich binnen en buiten de overheid bezig houdt met informatiebeveiliging. We onderzochten hoe het gesteld is met  (de organisatie van) informatiebeveiliging en doen concrete aanbevelingen over waar het beter kan. Maar liefst 50 organisaties (gemeenten, GGR’s en een provincie) deden mee aan het onderzoek." />
<div className="container">
<div className="overflow-hidden bg-white py-24 sm:py-32">
  <div className="mx-auto max-w-7xl ">
    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
      <div className="lg:pt-4 lg:pr-8">
        <div className="lg:max-w-lg">
          <h3 className="mt-2 text-3xl font-black tracking-tight text-pretty text-ocean-800 sm:text-3xl">Enkele highlights</h3>
          <p className="mt-6 text-lg/8 text-gray-700">Bij veel decentrale overheidsorganisaties worden te weinig maatregelen genomen. De maatregelen zijn slechts bij de helft van de organisaties effectief.</p>
          <p className="mt-6 text-lg/8 text-gray-700">
            72% van de respondenten zegt dat de risicoanalyse onvoldoende zegt over hoe de informatiebeveiliging ervoor staat in hun organisatie.
          </p>
          <p className="mt-6 text-lg/8 text-gray-700">
          Uit het beleid spreken bij de meerderheid van de organisaties goede intenties, maar er is onvoldoende navolging.
          </p>
          <p className="mt-6 text-lg/8 text-gray-700">
            De BIO 2.0 biedt een enorme kans voor verbetering. Een Information Security Management System is de weg naar blijvende borging en de manier om de Cyberbeveiligingswet (NIS2) te gaan implementeren.
          </p>
        </div>
        <div>
          <h3 className="mt-6 text-3xl font-black text-ocean-800">Krijg toegang</h3>
        <form className="mt-8 space-y-4 max-w-md" onSubmit={handleSubmit}>
          {submitStatus === 'success' && (
            <div className="p-4 bg-green-50 border border-green-200 rounded-md">
              <p className="text-green-800">Bedankt voor je interesse!<br/><br/>
                We sturen het onderzoek binnen twee werkdagen naar je op.
                </p>
            </div>
          )}
          {submitStatus === 'error' && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-md">
              <p className="text-red-800">Er is iets misgegaan. Probeer het later opnieuw.</p>
            </div>
          )}
          <div>
            <label htmlFor="naam" className="block text-sm font-medium text-gray-700">
              Naam <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="naam"
              name="naam"
              required
              className="mt-1 ml-1 block w-full border border-gray-300 shadow-sm focus:border-ocean-500 focus:ring-ocean-500 text-lg py-4 px-5"
              placeholder="Voornaam achternaam"
              style={{ minHeight: '3.5rem' }}
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              E-mailadres <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              className="mt-1 ml-1 block w-full border border-gray-300 shadow-sm focus:border-ocean-500 focus:ring-ocean-500 text-lg py-4 px-5"
              placeholder="info@triple-control.com"
              style={{ minHeight: '3.5rem' }}
            />
          </div>
          <div>
            <label htmlFor="phone" className="block text-base font-medium text-gray-700 mb-2">
              Telefoonnummer <span className="text-gray-400">(optioneel)</span>
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              className="mt-1 ml-1 block w-full border border-gray-300 shadow-sm focus:border-ocean-500 focus:ring-ocean-500 text-lg py-4 px-5"
              placeholder="085 820 09 03"
              style={{ minHeight: '3.5rem' }}
            />
          </div>
          <div className="pt-4">
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full py-3 px-6 font-bold rounded bg-passion-700 text-white hover:bg-passion-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Bezig met verzenden...' : 'Download het onderzoek'}
            </button>
          </div>
        </form>
        </div>
      <p className="text-xs text-gray-500 mt-6">
        Door je e-mailadres (en eventueel telefoonnummer) achter te laten ga je ermee akkoord dat wij deze gegevens gebruikt om het onderzoek naar je toe te sturen. We zijn verder natuurlijk benieuwd naar jouw ervaring. We kunnen daarom contact met je opnemen, uitsluitend met als doel om kort te bespreken hoe jouw ervaringen aansluiten op de uitkomsten van het onderzoek en/of in het kader van eventueel vervolgonderzoek. Meer informatie vind je in onze <a href="/privacy" className="underline text-blue-500">privacy policy</a>.
      </p>
      </div>

      <img src="images/cover.png" alt="Cover screenshot" className="w-3xl rounded-[3rem] shadow-xl ring-1 ring-gray-400/10 hidden lg:block"/>
    </div>
  </div>
</div>
</div>

    </main>
  );
}

export default Onderzoek;